import * as graphql from '@/functions/graphql.js'
import * as errorHandeling from '@/functions/errorHandeling.js'
import store from '.';

const state = {
  CMSComponents: [],
  menuColors: [],
  meshNames: [],
  menuGlasTypes: [],
  menuInfoboxSettings: [],
  menuUISettings: [],
  textures: null,
  houtsoortTypes: [],
  plankTypes: null,  
  plankLocations: null,
  newComponent: null,
  types: null,
  infoboxes: [], // for the dropdown
  modelCategories:null,
  models: null,
  bergingTypes: null,
  schuifwandTypes: [],
  schuifwandWidthRanges: [],
  users: null,
  backups: null,
  materials: [],
  globalSettings: {},
  funderingTypes: [],
  funderingTypesPublic: [],
  dakgootTypes: [],
  dakgootTypesPublic: [],
  schuifwandOptions: [],
  schuifwandOptionsPublic: [],
}

const cleanBreedtes = (breedtes) => {
  for (let i = 0; i < breedtes.length; i++) {
    const element = breedtes[i];
    element.artikelNummer = cleanWhitespace(element.artikelNummer);
  }
  return breedtes;
}
function cleanWhitespace(text) {
  return text.replace(/\s+/gi, '');
}

const mutations = {
  setCMSComponents (state, data) {
    state.CMSComponents = data
  },

  updateCMSComponents (state, c) {
    const index = state.CMSComponents.findIndex((cms) => cms.id === c.id)
    state.CMSComponents[index] = c
  },

  addCMSComponent (state, c) {
    state.CMSComponents.push(c)
    state.newComponent = c
  },

  removeCMSComponent (state, id) {
    const cIndex = state.CMSComponents.findIndex((c) => c.id === id)
    state.CMSComponents.splice(cIndex, 1)
  },

  setMenuColors (state, data) {
    state.menuColors = data
  },

  setMeshNames (state, data) {
    state.meshNames = data
  },

  setMenuGlasTypes (state, data) {
    state.menuGlasTypes = data
  },

  setMenuIsolatieTypes (state, data) {
    state.menuIsolatieTypes = data
  },

  setMenuInfoboxSettings (state, data) {
    state.menuInfoboxSettings = data
  },

  setMenuUISettings (state, data) {
    state.menuUISettings = data
  },

  setTextures (state, data) {
    state.textures = data
  },

  setTextureTypes (state, data) {
    state.textureTypes = data
  },

  setHoutsoortTypes (state, data) {
    state.houtsoortTypes = data
  },

  setPlankTypes (state, data) {
    state.plankTypes = data
  },

  setPlankLocations (state, data) {
    state.plankLocations = data
  },

  setModelsInfo (state, data) {
    state.types = data.getTypes
    state.infoboxes = data.getInfoboxes
    state.modelCategories = data.getModelCategories
    state.bergingTypes = data.getBergingTypes
    state.models = data.getModels
  },

  setTypes (state, data) {
    state.types = data
  },

  setModelCategories (state, data) {
    state.modelCategories = data
  },

  setBergingTypes (state, data) {
    state.bergingTypes = data
  },

  setSchuifwandTypes (state, data) {
    state.schuifwandTypes = data
  },

  schuifwandWidthRanges (state, data) {
    state.schuifwandWidthRanges = data
  },

  setUsers (state, data) {
    state.users = data
  },

  setUser (state, data) {
    state.user = data
  },

  setBackups (state, data) {
    state.backups = data
  },

  setMaterials (state, data) {
    state.materials = data
  },

  setFunderingTypes (state, data) {
    state.funderingTypes = data
  },

  setFunderingTypesPublic (state, data) {
    state.funderingTypesPublic = data
  },

  setGlobalSettings (state, data) {
    state.globalSettings = data
  },

  setDakgootTypes (state, data) {
    state.dakgootTypes = data
  },

  setDakgootTypesPublic (state, data) {
    state.dakgootTypesPublic = data
  },
  
  setInfoboxes (state, data) {
    state.infoboxes = data
  },

  setSchuifwandOptions (state, data) {
    state.schuifwandOptions = data
  },

  setSchuifwandOptionsPublic (state, data) {
    state.schuifwandOptionsPublic = data
  }
}

const actions = {
  async getCMSComponents (context) {

    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getCMSComponents {
            id
            code
            combinedCode
            category
            glasTypes {
              name
              acronym
              code
            }
            name
            shortName
            description
            infobox
            infoboxOnline
            variantShortName
            size
            trueOnline
            keyWords
            options {
              name
              subCode
            }
            colors {
              name
              hexCode
              code
            }
            dimensions {
              x
              y
              z
              xo
              yo
              zo
            }
            margins {
              xPos1
              xPos2
              xNeg1
              xNeg2
              yPos1
              yPos2
              yNeg1
              yNeg2
              zPos1
              zPos2
              zNeg1
              zNeg2
            }
            wallOptions {
              left
              center
              right
            }
            facadeOptions {
              left
              center
              right
            }
            variants {
              name
              code
            }
          }
        }
      `
    } // variants added to query for TASK-1438

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch components.')
    }

    context.commit('setCMSComponents', response.data.getCMSComponents)
  },

  /* -------------------------------------------------------------------------- */
  /*                             update menu kleuren                            */
  /* -------------------------------------------------------------------------- */

      async getMenuColors (context) {
        // config graphQL data
        const graphqlQuery = {
          query: `
            {
              getMenuColors {
                id
                name
                hexCode
                open
              }
            }
          `
        }

        

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to fetch menu colors.')
        }

        context.commit('setMenuColors', response.data.getMenuColors)
        },

      async updateMenuColors (context, colors) {

        let inputColor = colors.map((x) => {
          return `{
            id: "${x.id}",
            name: "${x.name}", 
            hexCode: "${x.hexCode}",
            open: ${x.open}
          }`
        })

        // config graphQL data
        const graphqlQuery = {
          query: `
            mutation {
              updateMenuColors(colors: [${inputColor}]) {
                id
                name
                hexCode
                open
              }
            }
          `
        }

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to update menu colors.')
        }

    context.commit('setMenuColors', response.data.updateMenuColors)
    await context.dispatch('updateDWTables', {
      succesText: 'Menu kleuren succesvol aangepast.',
      tableData: response.data.updateMenuColors,
      menuName: "updateMenuColors"
    })
  },

  /* ---------------------------- end menu kleuren ---------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                              update mesh names                             */
  /* -------------------------------------------------------------------------- */

      async getMeshNames (context) {
        // config graphQL data
        const graphqlQuery = {
          query: `
            {
              getMeshNames {
                id
                meshName
              }
            }
          `
        }

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to fetch mesh names.')
        }

        const meshNames = response?.data?.getMeshNames || []
        context.commit('setMeshNames', meshNames)
      },

      async updateMeshNames (context, meshNames) {

        let inputMeshNames = meshNames.map((x) => {
          return `{
            id: "${x.id}",
            meshName: "${x.meshName}"
          }`
        })

        // config graphQL data
        const graphqlQuery = {
          query: `
            mutation {
              updateMeshNames(meshnames: [${inputMeshNames}]) {
                id
                meshName
              }
            }
          `
        }

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to update mesh names.')
        }

    const updatedMeshNames = response?.data?.updateMeshNames || []
    context.commit('setMeshNames', updatedMeshNames)
    await context.dispatch('updateDWTables', {
      succesText: 'Mesh names succesvol aangepast.',
      tableData: updatedMeshNames,
      menuName: "updateMeshNames"
    })
  },

  /* --------------------------- end mesh names --------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                             update menu glastypes                          */
  /* -------------------------------------------------------------------------- */
    
      async getMenuGlasTypes (context) {
        // config graphQL data
        const graphqlQuery = {
          query: `
            {
              getMenuGlasTypes {
                id
                name
                acronym
              }
            }
          `
        }


      // sending request to server
      const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

      // if error
      if (response.errors) {
        errorHandeling.throwError(context, response, 'Failed to fetch menu glastypes.')
      }

      context.commit('setMenuGlasTypes', response.data.getMenuGlasTypes)
      },

      async updateMenuGlasTypes (context, glasTypes) {

        let inputGlasType = glasTypes.map((x) => {
          return `{
            id: "${x.id}",
            name: "${x.name}", 
            acronym: "${x.acronym}"
          }`
        })

        // config graphQL data
        const graphqlQuery = {
          query: `
            mutation {
              updateMenuGlasTypes(glastypes: [${inputGlasType}]) {
                id
                name
                acronym
              }
            }
          `
        }

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to update menu Glastypes.')
        }

        context.commit('setMenuGlasTypes', response.data.updateMenuGlasTypes)
        await context.dispatch('updateDWTables', {succesText: 'Menu Glastypes succesvol aangepast.', data: glasTypes, menuID: 1})
      },

  /* ---------------------------- end menu glastypes ---------------------------- */

/* -------------------------------------------------------------------------- */
  /*                             menu isolatietypes                          */
  /* -------------------------------------------------------------------------- */
    
  async getMenuIsolatieTypes (context) {
    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getMenuIsolatieTypes {
            id
            name
            description
          }
        }
      `
    }


  // sending request to server
  const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

  // if error
  if (response.errors) {
    errorHandeling.throwError(context, response, 'Failed to fetch menu isolatietypes.')
  }
  // console.log('response.data',response.data);
  context.commit('setMenuIsolatieTypes', response.data.getMenuIsolatieTypes);
  },

  async updateMenuIsolatieTypes (context, isolatieTypes) {

    let inputIsolatieType = isolatieTypes.map((x) => {
      return `{
        id: "${x.id}",
        name: "${x.name}", 
        description: "${x.description}"
      }`
    })

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateMenuIsolatieTypes(isolatietypes: [${inputIsolatieType}]) {
            id
            name
            description
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update menu Isolatietypes.')
    }

    context.commit('setMenuIsolatieTypes', response.data.updateMenuIsolatieTypes)
    await context.dispatch('updateDWTables', {succesText: 'Menu Isolatietypes succesvol aangepast.', data: isolatieTypes, menuID: 1})
  },

/* ---------------------------- end menu isolatietypes ---------------------------- */

/* -------------------------------------------------------------------------- */
/*                            update menu infoboxsettings                     */
/* -------------------------------------------------------------------------- */  

      async getMenuInfoboxSettings (context) {
        // config graphQL data
        const graphqlQuery = {
          query: `
            {
              getMenuInfoboxSettings {
                id
                uiIndex
                name
                title
                header
                urlEnding
              }
            }
          `
        }


      // sending request to server
      const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

      // if error
      if (response.errors) {
        errorHandeling.throwError(context, response, 'Failed to fetch menu infoboxsettings.')
      }

      context.commit('setMenuInfoboxSettings', response.data.getMenuInfoboxSettings)
      },

      async updateMenuInfoboxSettings (context, infoBoxSettings) {
        // console.log('infoBoxSettings',infoBoxSettings)

        let inputInfo = infoBoxSettings.map((x) => {
          return `{
            id: "${x.id}",
            name: "${x.name}", 
            title: "${x.title}",
            header: "${x.header}",
          }`
        })

        // config graphQL data
        const graphqlQuery = {
          query: `
            mutation {
              updateMenuInfoboxSettings(infoboxsettings: [${inputInfo}]) {
                id
                uiIndex
                name
                title
                header
                urlEnding
              }
            }
          `
        }

        // sending request to server
        // console.log('query', graphqlQuery)
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to update menu infoboxsettings.')
        }

        context.commit('setMenuInfoboxSettings', response.data.updateMenuInfoboxSettings)
        // await context.dispatch('updateDWTables', {succesText: 'Menu infoboxsettings succesvol aangepast.', data: infoBoxSettings, menuID: 1})
      },

      async updateInfoboxImage (context, uploadObject) {
        // console.log('uploadObject',uploadObject)
        let input = `{
            id: "${uploadObject.id}",
            image: "${uploadObject.image}",
            urlEnding: "${uploadObject.urlEnding }",
          }`

        // config graphQL data
        const graphqlQuery = {
          query: `
            mutation {
              updateInfoboxImage(infoboxImageUpload: ${input}) {
                id
                uiIndex
                name
                title
                header
                urlEnding
              }
            }
          `
        }

        // sending request to server
        const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

        // if error
        if (response.errors) {
          errorHandeling.throwError(context, response, 'Failed to update infobox image.')
        }

        context.commit('setMenuInfoboxSettings', response.data.updateMenuInfoboxSettings)
        // await context.dispatch('updateDWTables', {succesText: 'Menu infoboxsettings succesvol aangepast.', data: infoBoxSettings, menuID: 1})
      },
/* ---------------------------- end menu infoboxsettings ------------------------- */


/* -------------------------------------------------------------------------- */
/*                            update menu uisettings                     */
/* -------------------------------------------------------------------------- */  

async getMenuUISettings (context) {
  // config graphQL data
  const graphqlQuery = {
    query: `
      {
        getMenuUISettings {
          id
          maatwerkInfobox
          isolatieInfobox
          showProductDetails
          showPrice
          extraDetails {
            id
            text
          }
          extraQuestions {
            id
            text
            options {
              id
              text
            }
          }
        }
      }
    `
  }


// sending request to server
const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

// if error
if (response.errors) {
  errorHandeling.throwError(context, response, 'Failed to fetch menu uisettings.')
}

context.commit('setMenuUISettings', response.data.getMenuUISettings)
},

async updateMenuUISettings (context, uiSettings) {
  // console.log('uiSettings',uiSettings)

  // Build a safe GraphQL input payload from UI data.
  // Notes:
  // - GraphQL string literals must have quotes and backslashes escaped.
  // - Schema expects String IDs for maatwerkInfobox/isolatieInfobox, so we quote them.
  // - Arrays are rendered as inline GraphQL lists (comma-separated inside [ ... ]).
  // - Booleans can be inserted as-is (true/false) without quotes.
  
  // Escape helper for GraphQL string literals.
  // Ensures user-provided text (IDs, labels) cannot break the mutation string.
  // 1) Coerces undefined/null to empty string
  // 2) Escapes backslashes
  // 3) Escapes double quotes
  const esc = (s) => String(s ?? '')
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"');

  let inputInfo = uiSettings.map((x) => {
    // Convert extraDetails array -> GraphQL input objects
    let extraDetails = (x.extraDetails || []).map((detail) => {
      return `{
        id: "${esc(detail.id)}",
        text: "${esc(detail.text)}"
      }`
    }).join(',');

    // Convert extraQuestions (and nested options) -> GraphQL input objects
    let extraQuestions = (x.extraQuestions || []).map((question) => {
      let options = (question.options || []).map((option) => {
        return `{
          id: "${esc(option.id)}",
          text: "${esc(option.text)}"
        }`
      }).join(',');

      return `{
        id: "${esc(question.id)}",
        text: "${esc(question.text)}",
        options: [${options}]
      }`
    }).join(',');

    return `{
      id: "${esc(x.id)}",
      maatwerkInfobox: "${esc(x.maatwerkInfobox)}",
      isolatieInfobox: "${esc(x.isolatieInfobox)}",
      showProductDetails: ${x.showProductDetails}, 
      showPrice: ${x.showPrice},
      extraDetails: [${extraDetails}],
      extraQuestions: [${extraQuestions}]
    }`;
  });

  // config graphQL data
  const graphqlQuery = {
    query: `
      mutation {
        updateMenuUISettings(uisettings: [${inputInfo}]) {
          id
          maatwerkInfobox
          isolatieInfobox
          showProductDetails
          showPrice
          extraDetails {
            id
            text
          }
          extraQuestions {
            id
            text
            options {
              id
              text
            }
          }
        }
      }
    `
  }

  // sending request to server
  // console.log(graphqlQuery)
  const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

  // if error
  if (response.errors) {
    errorHandeling.throwError(context, response, 'Failed to update menu uisettings.')
  }

  context.commit('setMenuUISettings', response.data.updateMenuUISettings)
  // await context.dispatch('updateDWTables', {succesText: 'Menu uisettings succesvol aangepast.', data: uiSettings, menuID: 1})
},

// async updateInfoboxImage (context, uploadObject) {
//   // console.log('uploadObject',uploadObject)
//   let input = `{
//       id: "${uploadObject.id}",
//       image: "${uploadObject.image}",
//       urlEnding: "${uploadObject.urlEnding }",
//     }`

//   // config graphQL data
//   const graphqlQuery = {
//     query: `
//       mutation {
//         updateInfoboxImage(infoboxImageUpload: ${input}) {
//           id
//           uiIndex
//           name
//           title
//           header
//           urlEnding
//         }
//       }
//     `
//   }

//   // sending request to server
//   const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

//   // if error
//   if (response.errors) {
//     errorHandeling.throwError(context, response, 'Failed to update infobox image.')
//   }

//   context.commit('setMenuInfoboxSettings', response.data.updateMenuInfoboxSettings)
//   // await context.dispatch('updateDWTables', {succesText: 'Menu infoboxsettings succesvol aangepast.', data: infoBoxSettings, menuID: 1})
// },
/* ---------------------------- end menu uisettings ------------------------- */

/* -------------------------------------------------------------------------- */
/*                            update menu textures                            */
/* -------------------------------------------------------------------------- */

  async getTextures (context) {
    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getTextures {
            id
            name
            url
            textureType
            imageForUI
            plankType
            color
            houtsoort
            locations
            scalingX
            scalingY
            emissive
            emissiveColor
            metalness
            order
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch texture files.')
    }
    context.commit('setTextures', response.data.getTextures)
  },

  async getTextureTypes (context) {
    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getTextureTypes {
            id
            name
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch texture types.')
    }
    context.commit('setTextureTypes', response.data.getTextureTypes)
  },

  async updateTextureTypes (context, textureTypes) {
    // textureTypes is an array of { id?: string, name: string }
    const input = textureTypes.map((x) => {
      return `{
        ${x.id ? `id: "${x.id}",` : ''}
        name: "${x.name}"
      }`
    })

    const graphqlQuery = {
      query: `
        mutation {
          updateTextureTypes(texturetypes: [${input}]) {
            id
            name
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update texture types.')
    }

    context.commit('setTextureTypes', response.data.updateTextureTypes)
    await context.dispatch('updateDWTables', {
      succesText: 'Texture types succesvol aangepast.',
      tableData: response.data.updateTextureTypes,
      menuName: 'updateTextureTypes'
    })
  },

  async getPlankTypes (context) {
    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getPlankTypes {
            id
            name
            image
            connection
            infobox {
              id
              uiIndex
              name
            }
            infoboxIsOnline
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch plank types.')
    }
    context.commit('setPlankTypes', response.data.getPlankTypes)
  },

  async getPlankLocations (context) {
    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getPlankLocations {
            id
            name
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch plank locations.')
    }
    context.commit('setPlankLocations', response.data.getPlankLocations)
  },

  async updateTextures(context, Textures) {
    //return new Promise((resolve) => {
    // console.log(Textures)
    const remove = Textures.remove.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        url: "${x.url}",
      }`
    })

    const update = Textures.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        url: "${x.url}",
        image: "${x.tempImageStorage}",
        textureType: "${x.textureType}",
        imageForUI: "${x.imageForUI}",
        plankType: "${x.plankType}",
        color: "${x.color}",
        houtsoort: "${x.houtsoort}",
        locations: ${JSON.stringify(x.locations)},
        ${x.order ? 'order: '+x.order : ''}
      }`
    })

    const insert = Textures.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        url: "${x.url}",
        image: "${x.tempImageStorage}",
        textureType: "${x.textureType}",
        imageForUI: "${x.imageForUI}",
        plankType: "${x.plankType}",
        color: "${x.color}",
        locations: ${JSON.stringify(x.locations)},
        ${x.order ? 'order: '+x.order : ''}
      }`
    })

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateTextures(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            url
            textureType
            imageForUI
            plankType
            color
            houtsoort
            locations
            order
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update textures.')
    }

    context.commit('setTextures', response.data.updateTextures)
    await context.dispatch('updateDWTables', {
      succesText: 'Textures succesvol aangepast.',
      tableData: response.data.updateTextures,
      menuName: "updateTextures"
    })
  },

  async getHoutsoortTypes (context) {
    const graphqlQuery = {
      query: `
        {
          getHoutsoortTypes {
            id
            name
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get houtsoort types.')
    }

    context.commit('setHoutsoortTypes', response.data.getHoutsoortTypes)
  },

  async updateHoutsoortTypes (context, houtsoortTypes) {
    const remove = houtsoortTypes.remove.map((x) => {
      return `{
        id: "${x.id}"
      }`
    })

    const update = houtsoortTypes.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
      }`
    })

    const insert = houtsoortTypes.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateHoutsoortTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
          }
        }
      `
    }
    // console.log(graphqlQuery, houtsoortTypes)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update houtsoort types.')
    }

    context.commit('setHoutsoortTypes', response.data.updateHoutsoortTypes)
  },

  async updatePlankTypes(context, PlankTypes) {
    // console.log(PlankTypes.remove)
    const remove = PlankTypes.remove.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        image: "${x.image}",
      }`
    })

    const update = PlankTypes.update.map((x) => {
      // console.log(PlankTypes.update)
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        image: "${x.image}",
        tempImage: "${x.tempImageStorage}",
        connection: "${x.connection}",
        infobox: {
          id: "${x.infobox.id}",
          name: "${x.infobox.name}",
          uiIndex: "${x.infobox.uiIndex}"
        } 
        infoboxIsOnline: ${!!x.infoboxIsOnline}
      }`
    })

    const insert = PlankTypes.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        image: "${x.image}",
        tempImage: "${x.tempImageStorage}",
        connection: "${x.connection}",
        infobox: {
          id: "${x.infobox.id}",
          name: "${x.infobox.name}",
          uiIndex: "${x.infobox.uiIndex}"
        } 
        infoboxIsOnline: ${!!x.infoboxIsOnline}
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updatePlankTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            image
            connection
            infobox {
              id
              uiIndex
              name
            }
            infoboxIsOnline
          }
        }
      `
    }
    // console.log(graphqlQuery)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)
    // console.log('response', response);

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update plank types.')
    }

    context.commit('setPlankTypes', response.data.updatePlankTypes)
    await context.dispatch('updateDWTables', {
      succesText: 'Plank types succesvol aangepast.',
      tableData: response.data.updatePlankTypes,
      menuName: "updatePlankTypes"
    })
  },

  async getModelsInfo (context) {

    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getTypes {
            id
            name
            urls {
              dev
              tes
              pro
            }
            index
          }

          getInfoboxes {
            id
            uiIndex
            name
          }

          getModelCategories {
            id
            name
          }

          getBergingTypes {
            id
            name
            order
          }

          getModels {
            id
            name
            type {
              id
              name
              urls {
                dev
                tes
                pro
              }
              index
            }
            infobox {
              id 
              uiIndex
              name
            }
            infoboxIsOnline
            category {
              id
              name
            }
            online
            maatwerk {
              enabled
              width {
                min
                max
              }
              depth {
                min
                max
              }
            }
            standaardmatenDisabled
            wall {
              minWallWidth
              needsSpaceForStaander
            }
            roofFinishes 
            wallFinishes {
              wandBuiten
              wandBinnen
              tussenWandLinks
              tussenWandRechts
              topgevelBuiten
              topgevelBinnen
              topgevelLinks
              topgevelRechts
            }
            overstekKlosRound
            availableOptions {
              fundering
              dakgoot
              lichtstraten
              ledverlichting
            }
            meshNames {
              staander
              poer
              betonband
              poerenplan
              regelwerk
              topgevel
              assets
              assetsWandvak
              asset
              lichtstraatGordingbalk
              tulp
            }
            defaultSizes {
              enabled
              diepte
              hoogtePaal
              maximaleMuurBreedte
              staanderDikte
              poer {
                z
                y
              }
              schoor {
                enabled
                meshName
                sz
                sy
                sx
                sox
                wallMinWidth
              }
              ringBalk {
                meshName
                hoekverbinding
                y
                z
              }
              extraRingBalk {
                enabled
                meshName
                gordingVorm
                y
                z
                position
              }
              ringbalkTussenPaal {
                enabled
                meshName
                y
                z
              }
              gordingBalk {
                meshName
                y
                z
                afstandTussenGordingen
                position
                ox
                oy
                oyl
              }
              extraBalkOpGording {
                enabled
                meshName
                y
                z
              }
              extraPlankAchter {
                enabled
                meshName
                y
                z
                xBov
                xOnd
                yKop
              }
              ringBalkGording {
                meshName
                y
                z
                position
              }
              overstekKlos {
                enabled
                meshName
                z
                zp
                xb
                xo
                y
                yk
                position{
                  left
                  right
                }
                zDik
                zDikPaal
                klosVoEnabled
                klosVoEditable
                xBovVo
                xOndVo
                yHooVo
                yKopVo
                klosAcEnabled
                klosAcEditable
                xBovAc
                xOndAc
                yHooAc
                yKopAc
                klosLiEnabled
                klosLiEditable
                xBovLi
                xOndLi
                yHooLi
                yKopLi
                klosReEnabled
                klosReEditable
                xBovRe
                xOndRe
                yHooRe
                yKopRe
                outsideMarginPraag
                losseKopMaxHartAfstand
              }
              boeideel {
                boeideelPlankMeshName
                boeideelLijstMeshName
                dekplankMeshName
                douglasPlankenMeshName
                enabled
                y
                z
                position
                lijstEnabled
                ly
                lz
                lijstPosition
                dpy
                dpz
                dpOffsetKopkant
                dpOffsetGootzijde
                nokpositie
                byl
                bylAchter
                douglasPlanken
                horizontaleOffset
                niceRegelwerkBreedte
                niceRegelwerkDikte
                niceRegelwerkMax
                niceRegelwerkVerticalBeamMaxGap
                niceRegelwerkMinLength
                niceRegelwerkMeshName
              }
              trim {
                enabled
                meshName
                y
                z
                overhang
                color
                position
              }
              dak {
                dakbeschotMeshName
                dakbedekkingMeshName
                offset
                helling
                hellingAchter
                overhang
                beschotDikte
                dakpanOverhang
                dakpanOverhangAchter
                gordingSchoorHoek
                gordingSchoorOffset
                dakbedekkingOpstand
              }
              dakgoot {
                meshName
                enabled
                y
                offset
                offsetAchter
                twoPipesWidth
                threePipesWidth
              }
              wall {
                meshName
                position
                wz
                height {
                  position
                  value
                }
              }
              omlijstingPalen
              omlijstingPalenData {
                meshName
                meshNameOnderplank
              }
              veranda {
                enabled
                meshName
                hoogte
                dikte
                extraBreedte
                material
              }
              breedtes {
                breedte
                bergingType
                artikelNummer
                wallDivision {
                  width
                  bergingEnabled
                }
                enabled
              }
            }
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch model info.')
    }

    context.commit('setModelsInfo', response.data)
  },

  async updateTypes (context, data) {

    const remove = data.remove.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        urls: {
          dev: "${x.urls.dev}",
          tes: "${x.urls.tes}",
          pro: "${x.urls.pro}",
        },
        index: ${x.index}
      }`
    })

    const update = data.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        urls: {
          dev: "${x.urls.dev}",
          tes: "${x.urls.tes}",
          pro: "${x.urls.pro}",
        },
        index: ${x.index}
      }`
    })

    const insert = data.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        urls: {
          dev: "${x.urls.dev}",
          tes: "${x.urls.tes}",
          pro: "${x.urls.pro}",
        },
        index: ${x.index}
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            urls {
              dev
              tes
              pro
            }
            index
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update model types.')
    }

    context.commit('setTypes', response.data.updateTypes)
    await context.dispatch('updateDWTables', {
      succesText: 'Types succesvol aangepast.',
      tableData: response.data.updateTypes,
      menuName: "updateTypes"
    })
  },

  async updateModelCategories (context, data) {

    const remove = data.remove.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}"
      }`
    })

    const update = data.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}"
      }`
    })

    const insert = data.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}"
      }`
    })

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateModelCategories(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update model categories.')
    }

    context.commit('setModelCategories', response.data.updateModelCategories)
    await context.dispatch('updateDWTables', {
      succesText: 'Model categorieën succesvol aangepast.',
      tableData: response.data.updateModelCategories,
      menuName: "updateModelCategories"
    })
  },

  async updateBergingTypes (context, data) {

    const remove = data.remove.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        order: ${x.order}
      }`
    })

    const update = data.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}"
        order: ${x.order}
      }`
    })

    const insert = data.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        order: ${x.order}
      }`
    })

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateBergingTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            order
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update berging types.')
    }
    // console.log(response)
    context.commit('setBergingTypes', response.data.updateBergingTypes)
    await context.dispatch('updateDWTables', {
      succesText: 'Berging types succesvol aangepast.',
      tableData: response.data.updateBergingTypes,
      menuName: "updateBergingTypes"
    })
  },

  async getSchuifwandTypes (context) {

    // config graphQL data
    const graphqlQuery = {
      query: `
        {
          getSchuifwandTypes {
            id
            minimaleBreedte
            maximaleBreedte
            glasplaatAantal
            glasplaatBreedte
            glasplaatDikte
            bovenrailHoogte
            onderrailHoogte
            railDikte
            glaspaneelHartAfstand
            glasprofielStaanderBreedte
            glasprofielStaanderDikte
            glasprofielLiggerBreedte
            glasprofielLiggerDikte
            handvatVerticalePositionering
            handvatHorizontalePositionering
            schuifrichting
            artikelnummers
            order
            image
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch schuifwand types.')
    }

    function mergeRanges(objects) {
      // Create a copy of the original array to avoid modifying it
      const sortedObjects = JSON.parse(JSON.stringify(objects)).sort((a, b) => a.minimaleBreedte - b.minimaleBreedte);
  
      const mergedRanges = [];
      let currentRange = sortedObjects[0];
  
      for (let i = 1; i < sortedObjects.length; i++) {
        const nextRange = sortedObjects[i];
        
        // If there is a gap between the current range and the next range, add the current range to the merged ranges
        if (currentRange.maximaleBreedte < nextRange.minimaleBreedte) {
            mergedRanges.push(currentRange);
            currentRange = nextRange;
        } else {
            // Merge the ranges
            currentRange.maximaleBreedte = Math.max(currentRange.maximaleBreedte, nextRange.maximaleBreedte);
        }
      }

      // Add the last range to the merged ranges
      mergedRanges.push(currentRange);

      return mergedRanges;
    }
    
    const schuifwandWidthRanges = mergeRanges(response.data.getSchuifwandTypes);
    const schuifwandWidthRangesMinMax = schuifwandWidthRanges.map((r) => { return {min: r.minimaleBreedte, max: r.maximaleBreedte }});
    context.commit('schuifwandWidthRanges', schuifwandWidthRangesMinMax)

    context.commit('setSchuifwandTypes', response.data.getSchuifwandTypes)
  },

  async updateUsers (context, data) {

    const update = data.update.map((x) => {
      return `{
        id: "${x.id}", 
        email: "${x.email}"
        superUser: ${x.superUser}
        collectionsAllowedToEdit: [${x.collectionsAllowedToEdit.map((y) => { return `"${y}"` })}]
      }`
    })

    // console.log(update)

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateUsers(update: [${update}]) {
            id
            email
            superUser
            collectionsAllowedToEdit
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update users.')
    }
    // console.log(response)
    context.commit('setUsers', response.data.updateUsers)
    await context.dispatch('updateDWTables', {
      succesText: 'Gebruikers succesvol aangepast.',
      tableData: response.data.updateUsers,
      menuName: "updateUsers"
    })
  },

  async migrateDatabase (context, {source, destination}) {

    const graphqlQuery = {
      query: `
        mutation {
          migrateComponents(source: ${source}, destination: ${destination})
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to migrate database.')
    }
    context.dispatch('showSucces', "Database succesfully migrated.")

  },

  async createBackup (context, database) {

    const graphqlQuery = {
      query: `
        mutation {
          createBackup(database: "${database}")
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to create backup')
    }
    context.dispatch('showSucces', `Succesfully created backup of ${database}.`)
    context.dispatch('getBackups', database)

  },

  async getBackups (context, database) {

    const graphqlQuery = {
      query: `
        mutation {
          getBackups(database: "${database}") {
            filename
            dateString
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch backups')
    }

    context.commit('setBackups', response.data.getBackups)

  },

  async restoreBackup (context, {database, filename, shouldBackupDatabaseBeforeRestore}) {

    const graphqlQuery = {
      query: `
        mutation {
          restoreBackup(database: "${database}", filename: "${filename}", shouldBackup: ${shouldBackupDatabaseBeforeRestore}) {
            filename
            dateString
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to restore backup')
    }
    context.commit('setBackups', response.data.restoreBackup)
    context.dispatch('showSucces', `Succesfully restored backup.`)

  },    

  async createModel (context, data) {

    const sizes = data.defaultSizes.map((x) => {
      return `{
        enabled: ${x.enabled},
        diepte: ${x.diepte},
        hoogtePaal: ${x.hoogtePaal},
        maximaleMuurBreedte: ${x.maximaleMuurBreedte},
        staanderDikte: ${x.staanderDikte},
        poer: {
          z: ${x.poer.z},
          y: ${x.poer.y},
        }
        schoor: {
          enabled: ${x.schoor.enabled}
          meshName: "${x.schoor.meshName}",
          sz: ${x.schoor.sz},
          sy: ${x.schoor.sy},
          sx: ${x.schoor.sx},
          sox: ${x.schoor.sox}
          wallMinWidth: ${x.schoor.wallMinWidth}
        },
        ringBalk: {
          meshName: "${x.ringBalk.meshName}",
          hoekverbinding: "${x.ringBalk.hoekverbinding}",
          y: ${x.ringBalk.y},
          z: ${x.ringBalk.z},
        },
        extraRingBalk: {
          enabled: ${x.extraRingBalk.enabled},
          meshName: "${x.extraRingBalk.meshName}",
          gordingVorm: ${x.extraRingBalk.gordingVorm},
          y: ${x.extraRingBalk.y},
          z: ${x.extraRingBalk.z},
          position: ${x.extraRingBalk.position},
        },
        ringbalkTussenPaal: {
          enabled: ${x.ringbalkTussenPaal.enabled},
          meshName: "${x.ringbalkTussenPaal.meshName}",
          y: ${x.ringbalkTussenPaal.y},
          z: ${x.ringbalkTussenPaal.z},
        }        
        gordingBalk: {
          meshName: "${x.gordingBalk.meshName}",
          y: ${x.gordingBalk.y},
          z: ${x.gordingBalk.z},
          afstandTussenGordingen: ${x.gordingBalk.afstandTussenGordingen},
          position: ${x.gordingBalk.position},
          ox: ${x.gordingBalk.ox},
          oy: ${x.gordingBalk.oy},
          oyl: ${x.gordingBalk.oyl}
        },
        extraBalkOpGording: {
          enabled: ${x.extraBalkOpGording.enabled},
          meshName: "${x.extraBalkOpGording.meshName}",
          y: ${x.extraBalkOpGording.y},
          z: ${x.extraBalkOpGording.z}
        },
        extraPlankAchter: {
          enabled: ${x.extraPlankAchter.enabled},
          meshName: "${x.extraPlankAchter.meshName}",
          y: ${x.extraPlankAchter.y},
          z: ${x.extraPlankAchter.z},
          xBov: ${x.extraPlankAchter.xBov},
          xOnd: ${x.extraPlankAchter.xOnd},
          yKop: ${x.extraPlankAchter.yKop}
        },
        ringBalkGording: {
          meshName: "${x.ringBalkGording.meshName}",
          y: ${x.ringBalkGording.y},
          z: ${x.ringBalkGording.z},
          position: ${x.ringBalkGording.position}
        }
        overstekKlos: {
          enabled: ${x.overstekKlos.enabled},
          meshName: "${x.overstekKlos.meshName}",
          z: ${x.overstekKlos.z},
          zp: ${x.overstekKlos.zp},
          xb: ${x.overstekKlos.xb},
          xo: ${x.overstekKlos.xo},
          y: ${x.overstekKlos.y},
          yk: ${x.overstekKlos.yk},
          position: {
            left: ${x.overstekKlos.position.left},
            right: ${x.overstekKlos.position.right}
          },
          zDik: ${x.overstekKlos.zDik},
          zDikPaal: ${x.overstekKlos.zDikPaal},
          klosVoEnabled: ${x.overstekKlos.klosVoEnabled},
          klosVoEditable: ${x.overstekKlos.klosVoEditable},
          xBovVo: ${x.overstekKlos.xBovVo},
          xOndVo: ${x.overstekKlos.xOndVo},
          yHooVo: ${x.overstekKlos.yHooVo},
          yKopVo: ${x.overstekKlos.yKopVo},
          klosAcEnabled: ${x.overstekKlos.klosAcEnabled},
          klosAcEditable: ${x.overstekKlos.klosAcEditable},
          xBovAc: ${x.overstekKlos.xBovAc},
          xOndAc: ${x.overstekKlos.xOndAc},
          yHooAc: ${x.overstekKlos.yHooAc},
          yKopAc: ${x.overstekKlos.yKopAc},
          klosLiEnabled: ${x.overstekKlos.klosLiEnabled},
          klosLiEditable: ${x.overstekKlos.klosLiEditable},
          xBovLi: ${x.overstekKlos.xBovLi},
          xOndLi: ${x.overstekKlos.xOndLi},
          yHooLi: ${x.overstekKlos.yHooLi},
          yKopLi: ${x.overstekKlos.yKopLi},
          klosReEnabled: ${x.overstekKlos.klosReEnabled},
          klosReEditable: ${x.overstekKlos.klosReEditable},
          xBovRe: ${x.overstekKlos.xBovRe},
          xOndRe: ${x.overstekKlos.xOndRe},
          yHooRe: ${x.overstekKlos.yHooRe},
          yKopRe: ${x.overstekKlos.yKopRe},
          outsideMarginPraag: ${x.overstekKlos.outsideMarginPraag},
          losseKopMaxHartAfstand: ${x.overstekKlos.losseKopMaxHartAfstand}
        },
        boeideel: {
          enabled: ${x.boeideel.enabled},
          boeideelPlankMeshName: "${x.boeideel.boeideelPlankMeshName}",
          boeideelLijstMeshName: "${x.boeideel.boeideelLijstMeshName}",
          dekplankMeshName: "${x.boeideel.dekplankMeshName}",
          douglasPlankenMeshName: "${x.boeideel.douglasPlankenMeshName}",
          y: ${x.boeideel.y},
          z: ${x.boeideel.z},
          position: ${x.boeideel.position},
          lijstEnabled: ${x.boeideel.lijstEnabled},
          ly: ${x.boeideel.ly},
          lz: ${x.boeideel.lz},
          lijstPosition: ${x.boeideel.lijstPosition},
          dpy: ${x.boeideel.dpy},
          dpz: ${x.boeideel.dpz},
          dpOffsetKopkant: ${x.boeideel.dpOffsetKopkant},
          dpOffsetGootzijde: ${x.boeideel.dpOffsetGootzijde},
          nokpositie: ${x.boeideel.nokpositie},
          byl: ${x.boeideel.byl},
          bylAchter: ${x.boeideel.bylAchter},
          douglasPlanken: ${x.boeideel.douglasPlanken},
          horizontaleOffset: ${x.boeideel.horizontaleOffset},
          niceRegelwerkBreedte: ${x.boeideel.niceRegelwerkBreedte},
          niceRegelwerkDikte: ${x.boeideel.niceRegelwerkDikte},
          niceRegelwerkMax: ${x.boeideel.niceRegelwerkMax},
          niceRegelwerkVerticalBeamMaxGap: ${x.boeideel.niceRegelwerkVerticalBeamMaxGap},
          niceRegelwerkMinLength: ${x.boeideel.niceRegelwerkMinLength},
          niceRegelwerkMeshName: "${x.boeideel.niceRegelwerkMeshName}"
        },
        trim: {
          enabled: ${x.trim.enabled},
          meshName: "${x.trim.meshName}",
          y: ${x.trim.y},
          z: ${x.trim.z},
          overhang: ${x.trim.overhang},
          color: ${JSON.stringify(x.trim.color).replace(/"([^"]+)":/g, '$1:')}
          position: ${x.trim.position},
        }
        dak: {
          dakbeschotMeshName: "${x.dak.dakbeschotMeshName}",
          dakbedekkingMeshName: "${x.dak.dakbedekkingMeshName}",
          offset: ${x.dak.offset},
          helling: ${x.dak.helling},
          hellingAchter: ${x.dak.hellingAchter},
          overhang: ${x.dak.overhang},
          beschotDikte: ${x.dak.beschotDikte},
          dakpanOverhang: ${x.dak.dakpanOverhang},
          dakpanOverhangAchter: ${x.dak.dakpanOverhangAchter},
          gordingSchoorHoek: ${x.dak.gordingSchoorHoek},
          gordingSchoorOffset: ${x.dak.gordingSchoorOffset},
          dakbedekkingOpstand: ${x.dak.dakbedekkingOpstand || 'null'}
        }
        dakgoot: {
          enabled: ${x.dakgoot.enabled},
          meshName: "${x.dakgoot.meshName}",
          y: ${x.dakgoot.y},
          offset: ${x.dakgoot.offset},
          offsetAchter: ${x.dakgoot.offsetAchter},
          twoPipesWidth: ${x.dakgoot.twoPipesWidth},
          threePipesWidth: ${x.dakgoot.threePipesWidth},
        }
        wall: {
          meshName: "${x.wall.meshName}",
          position: "${x.wall.position}",
          wz: ${x.wall.wz},
          height: ${JSON.stringify(x.wall.height).replace(/"([^"]+)":/g, '$1:')},
        }
        omlijstingPalen: ${x.omlijstingPalen},
        omlijstingPalenData: {
          meshName: "${x.omlijstingPalenData.meshName}",
          meshNameOnderplank: "${x.omlijstingPalenData.meshNameOnderplank}"
        },
        veranda: {
          enabled: ${x.veranda.enabled},
          meshName: "${x.veranda.meshName}",
          hoogte: ${x.veranda.hoogte},
          dikte: ${x.veranda.dikte},
          extraBreedte: ${x.veranda.extraBreedte},
          material: "${x.veranda.material}"
        }
        breedtes: ${JSON.stringify(cleanBreedtes(x.breedtes)).replace(/"([^"]+)":/g, '$1:')}
      },`
    })

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          createModel(modelInfo: {
            name: "${data.name}",
            type: {
              id: "${data.type.id}",
              name: "${data.type.name}"
            },
            infobox: {
              id: "${data.infobox.id}",
              uiIndex: "${data.infobox.uiIndex}",
              name: "${data.infobox.name}"
            },
            infoboxIsOnline: ${data.infoboxIsOnline},
            category: {
              id: "${data.category.id}",
              name: "${data.category.name}"
            },
            online: ${data.online},
            maatwerk: {
              enabled: ${data.maatwerk.enabled},
              width: {
                min: ${data.maatwerk.width.min},
                max: ${data.maatwerk.width.max}
              },
              depth: {
                min: ${data.maatwerk.depth.min},
                max: ${data.maatwerk.depth.max}
              }
            },
            standaardmatenDisabled: ${data.standaardmatenDisabled},
            wall: {
              minWallWidth: ${data.wall.minWallWidth},
              needsSpaceForStaander: ${data.wall.needsSpaceForStaander}
            },
            roofFinishes: ${JSON.stringify(data.roofFinishes)},
            wallFinishes: ${JSON.stringify(data.wallFinishes).replace(/"([^"]+)":/g, '$1:')}
            overstekKlosRound: ${data.overstekKlosRound},
            availableOptions: {
              fundering: ${data.availableOptions.fundering},
              dakgoot: ${data.availableOptions.dakgoot},
              lichtstraten: ${data.availableOptions.lichtstraten},
              ledverlichting: ${data.availableOptions.ledverlichting},
            },
            meshNames: {
              staander: "${data.meshNames.staander}",
              poer: "${data.meshNames.poer}",
              betonband: "${data.meshNames.betonband}",
              poerenplan: "${data.meshNames.poerenplan}",
              regelwerk: "${data.meshNames.regelwerk}",
              topgevel: "${data.meshNames.topgevel}",
              assets: "${data.meshNames.assets}",
              assetsWandvak: "${data.meshNames.assetsWandvak}",
              asset: "${data.meshNames.asset}",
              lichtstraatGordingbalk: "${data.meshNames.lichtstraatGordingbalk}",
              tulp: "${data.meshNames.tulp}"
            },
            defaultSizes: [${sizes}],
          }) {
            id
            name
            type {
              id
              name
              urls {
                dev
                tes
                pro
              }
              index
            }
            category {
              id
              name
            }
            online
            defaultSizes {
              enabled
              diepte
              hoogtePaal
              maximaleMuurBreedte
              staanderDikte
              poer {
                z
                y
              }
              schoor {
                enabled
                meshName
                sz
                sy
                sx
                sox
                wallMinWidth
              }
              ringBalk {
                meshName
                hoekverbinding
                y
                z
              }
              extraRingBalk {
                enabled
                meshName
                gordingVorm
                y
                z
                position
              }
              ringbalkTussenPaal {
                enabled
                meshName
                y
                z
              }
              gordingBalk {
                meshName
                y
                z
                afstandTussenGordingen
                position
                ox
                oy
                oyl
              }
              extraBalkOpGording {
                enabled
                meshName
                y
                z
              }
              extraPlankAchter {
                enabled
                meshName
                y
                z
                xBov
                xOnd
                yKop
              }
              ringBalkGording {
                meshName
                y
                z
                position
              }
              overstekKlos {
                enabled
                meshName
                z
                zp
                xb
                xo
                y
                yk
                position{
                  left
                  right
                }
                zDik
                zDikPaal
                klosVoEnabled
                klosVoEditable
                xBovVo
                xOndVo
                yHooVo
                yKopVo
                klosAcEnabled
                klosAcEditable
                xBovAc
                xOndAc
                yHooAc
                yKopAc
                klosLiEnabled
                klosLiEditable
                xBovLi
                xOndLi
                yHooLi
                yKopLi
                klosReEnabled
                klosReEditable
                xBovRe
                xOndRe
                yHooRe
                yKopRe
                outsideMarginPraag
                losseKopMaxHartAfstand
              }
              boeideel {
                enabled
                boeideelPlankMeshName
                boeideelLijstMeshName
                dekplankMeshName
                douglasPlankenMeshName
                y
                z
                position
                lijstEnabled
                ly
                lz
                lijstPosition
                dpy
                dpz
                dpOffsetKopkant
                dpOffsetGootzijde
                nokpositie
                byl
                bylAchter
                douglasPlanken
                horizontaleOffset
                niceRegelwerkBreedte
                niceRegelwerkDikte
                niceRegelwerkMax
                niceRegelwerkVerticalBeamMaxGap
                niceRegelwerkMinLength
                niceRegelwerkMeshName
              }
              trim {
                enabled
                meshName
                y
                z
                overhang
                color
                position
              }
              dak {
                dakbeschotMeshName
                dakbedekkingMeshName
                offset
                helling
                hellingAchter
                overhang
                beschotDikte
                dakpanOverhang
                dakpanOverhangAchter
                gordingSchoorHoek
                gordingSchoorOffset
                dakbedekkingOpstand
              }
              dakgoot {
                enabled
                meshName
                y
                offset
                offsetAchter
                twoPipesWidth
                threePipesWidth
              }
              wall {
                meshName
                position
                wz
                height {
                  position
                  value
                }
              }
              omlijstingPalen
              omlijstingPalenData {
                meshName
                meshNameOnderplank
              }
              veranda {
                enabled
                meshName
                hoogte
                dikte
                extraBreedte
                material
              }
              breedtes {
                breedte
                bergingType
                artikelNummer
                wallDivision {
                  width
                  bergingEnabled
                }
                enabled
              }
            }
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to create model.')
    }

    await context.dispatch('getModelsInfo')
    //context.commit('setModel', response.data.createModel)
    await context.dispatch('showSucces', 'Model succesvol gecreërd.')
  },

  async updateModel (context, data) {
    // console.log(data)
    const sizes = data.defaultSizes.map((x) => {
      return `{
        enabled: ${x.enabled},
        diepte: ${x.diepte},
        hoogtePaal: ${x.hoogtePaal},
        maximaleMuurBreedte: ${x.maximaleMuurBreedte},
        staanderDikte: ${x.staanderDikte},
        poer: {
          z: ${x.poer.z},
          y: ${x.poer.y},
        }
        schoor: {
          enabled: ${x.schoor.enabled}
          meshName: "${x.schoor.meshName}",
          sz: ${x.schoor.sz},
          sy: ${x.schoor.sy},
          sx: ${x.schoor.sx},
          sox: ${x.schoor.sox}
          wallMinWidth: ${x.schoor.wallMinWidth}
        },
        ringBalk: {
          meshName: "${x.ringBalk.meshName}",
          hoekverbinding: "${x.ringBalk.hoekverbinding}",
          y: ${x.ringBalk.y},
          z: ${x.ringBalk.z},
        },
        extraRingBalk: {
          enabled: ${x.extraRingBalk.enabled},
          meshName: "${x.extraRingBalk.meshName}",
          gordingVorm: ${x.extraRingBalk.gordingVorm},
          y: ${x.extraRingBalk.y},
          z: ${x.extraRingBalk.z},
          position: ${x.extraRingBalk.position},
        },
        ringbalkTussenPaal: {
          enabled: ${x.ringbalkTussenPaal.enabled},
          meshName: "${x.ringbalkTussenPaal.meshName}",
          y: ${x.ringbalkTussenPaal.y},
          z: ${x.ringbalkTussenPaal.z},
        }
        gordingBalk: {
          meshName: "${x.gordingBalk.meshName}",
          y: ${x.gordingBalk.y},
          z: ${x.gordingBalk.z},
          afstandTussenGordingen: ${x.gordingBalk.afstandTussenGordingen},
          position: ${x.gordingBalk.position}
          ox: ${x.gordingBalk.ox},
          oy: ${x.gordingBalk.oy},
          oyl: ${x.gordingBalk.oyl}
        },
        extraBalkOpGording: {
          enabled: ${x.extraBalkOpGording.enabled},
          meshName: "${x.extraBalkOpGording.meshName}",
          y: ${x.extraBalkOpGording.y},
          z: ${x.extraBalkOpGording.z}
        },
        extraPlankAchter: {
          enabled: ${x.extraPlankAchter.enabled},
          meshName: "${x.extraPlankAchter.meshName}",
          y: ${x.extraPlankAchter.y},
          z: ${x.extraPlankAchter.z},
          xBov: ${x.extraPlankAchter.xBov},
          xOnd: ${x.extraPlankAchter.xOnd},
          yKop: ${x.extraPlankAchter.yKop}
        },
        ringBalkGording: {
          meshName: "${x.ringBalkGording.meshName}",
          y: ${x.ringBalkGording.y},
          z: ${x.ringBalkGording.z},
          position: ${x.ringBalkGording.position}
        }
        overstekKlos: {
          enabled: ${x.overstekKlos.enabled},
          meshName: "${x.overstekKlos.meshName}",
          z: ${x.overstekKlos.z},
          zp: ${x.overstekKlos.zp},
          xb: ${x.overstekKlos.xb},
          xo: ${x.overstekKlos.xo},
          y: ${x.overstekKlos.y},
          yk: ${x.overstekKlos.yk},
          position: {
            left: ${x.overstekKlos.position.left},
            right: ${x.overstekKlos.position.right}
          },
          zDik: ${x.overstekKlos.zDik},
          zDikPaal: ${x.overstekKlos.zDikPaal},
          klosVoEnabled: ${x.overstekKlos.klosVoEnabled},
          klosVoEditable: ${x.overstekKlos.klosVoEditable},
          xBovVo: ${x.overstekKlos.xBovVo},
          xOndVo: ${x.overstekKlos.xOndVo},
          yHooVo: ${x.overstekKlos.yHooVo},
          yKopVo: ${x.overstekKlos.yKopVo},
          klosAcEnabled: ${x.overstekKlos.klosAcEnabled},
          klosAcEditable: ${x.overstekKlos.klosAcEditable},
          xBovAc: ${x.overstekKlos.xBovAc},
          xOndAc: ${x.overstekKlos.xOndAc},
          yHooAc: ${x.overstekKlos.yHooAc},
          yKopAc: ${x.overstekKlos.yKopAc},
          klosLiEnabled: ${x.overstekKlos.klosLiEnabled},
          klosLiEditable: ${x.overstekKlos.klosLiEditable},
          xBovLi: ${x.overstekKlos.xBovLi},
          xOndLi: ${x.overstekKlos.xOndLi},
          yHooLi: ${x.overstekKlos.yHooLi},
          yKopLi: ${x.overstekKlos.yKopLi},
          klosReEnabled: ${x.overstekKlos.klosReEnabled},
          klosReEditable: ${x.overstekKlos.klosReEditable},
          xBovRe: ${x.overstekKlos.xBovRe},
          xOndRe: ${x.overstekKlos.xOndRe},
          yHooRe: ${x.overstekKlos.yHooRe},
          yKopRe: ${x.overstekKlos.yKopRe},
          outsideMarginPraag: ${x.overstekKlos.outsideMarginPraag},
          losseKopMaxHartAfstand: ${x.overstekKlos.losseKopMaxHartAfstand}
        },
        boeideel: {
          enabled: ${x.boeideel.enabled},
          boeideelPlankMeshName: "${x.boeideel.boeideelPlankMeshName}",
          boeideelLijstMeshName: "${x.boeideel.boeideelLijstMeshName}",
          dekplankMeshName: "${x.boeideel.dekplankMeshName}",
          douglasPlankenMeshName: "${x.boeideel.douglasPlankenMeshName}",
          y: ${x.boeideel.y},
          z: ${x.boeideel.z},
          position: ${x.boeideel.position},
          lijstEnabled: ${x.boeideel.lijstEnabled},
          ly: ${x.boeideel.ly},
          lz: ${x.boeideel.lz},
          lijstPosition: ${x.boeideel.lijstPosition},
          dpy: ${x.boeideel.dpy},
          dpz: ${x.boeideel.dpz},
          dpOffsetKopkant: ${x.boeideel.dpOffsetKopkant},
          dpOffsetGootzijde: ${x.boeideel.dpOffsetGootzijde},
          nokpositie: ${x.boeideel.nokpositie},
          byl: ${x.boeideel.byl},
          bylAchter: ${x.boeideel.bylAchter},
          douglasPlanken: ${x.boeideel.douglasPlanken},
          horizontaleOffset: ${x.boeideel.horizontaleOffset},
          niceRegelwerkBreedte: ${x.boeideel.niceRegelwerkBreedte},
          niceRegelwerkDikte: ${x.boeideel.niceRegelwerkDikte},
          niceRegelwerkMax: ${x.boeideel.niceRegelwerkMax},
          niceRegelwerkVerticalBeamMaxGap: ${x.boeideel.niceRegelwerkVerticalBeamMaxGap},
          niceRegelwerkMinLength: ${x.boeideel.niceRegelwerkMinLength},
          niceRegelwerkMeshName: "${x.boeideel.niceRegelwerkMeshName}"
        },
        trim: {
          enabled: ${x.trim.enabled},
          meshName: "${x.trim.meshName}",
          y: ${x.trim.y},
          z: ${x.trim.z},
          overhang: ${x.trim.overhang},
          color: ${JSON.stringify(x.trim.color).replace(/"([^"]+)":/g, '$1:')}
          position: ${x.trim.position},
        }
        dak: {
          dakbeschotMeshName: "${x.dak.dakbeschotMeshName}",
          dakbedekkingMeshName: "${x.dak.dakbedekkingMeshName}",
          offset: ${x.dak.offset},
          helling: ${x.dak.helling},
          hellingAchter: ${x.dak.hellingAchter},
          overhang: ${x.dak.overhang},
          beschotDikte: ${x.dak.beschotDikte},
          dakpanOverhang: ${x.dak.dakpanOverhang},
          dakpanOverhangAchter: ${x.dak.dakpanOverhangAchter},
          gordingSchoorHoek: ${x.dak.gordingSchoorHoek},
          gordingSchoorOffset: ${x.dak.gordingSchoorOffset},
          dakbedekkingOpstand: ${x.dak.dakbedekkingOpstand || 'null'}
        }
        dakgoot: {
          enabled: ${x.dakgoot.enabled},
          meshName: "${x.dakgoot.meshName}",
          y: ${x.dakgoot.y},
          offset: ${x.dakgoot.offset},
          offsetAchter: ${x.dakgoot.offsetAchter},
          twoPipesWidth: ${x.dakgoot.twoPipesWidth},
          threePipesWidth: ${x.dakgoot.threePipesWidth},
        }
        wall: {
          meshName: "${x.wall.meshName}",
          position: "${x.wall.position}",
          wz: ${x.wall.wz},
          height: ${JSON.stringify(x.wall.height).replace(/"([^"]+)":/g, '$1:')},
        }
        omlijstingPalen: ${x.omlijstingPalen},
        omlijstingPalenData: {
          meshName: "${x.omlijstingPalenData.meshName}",
          meshNameOnderplank: "${x.omlijstingPalenData.meshNameOnderplank}"
        },
        veranda: {
          enabled: ${x.veranda.enabled},
          meshName: "${x.veranda.meshName}",
          hoogte: ${x.veranda.hoogte},
          dikte: ${x.veranda.dikte},
          extraBreedte: ${x.veranda.extraBreedte},
          material: "${x.veranda.material}"
        }
        breedtes: ${JSON.stringify(cleanBreedtes(x.breedtes)).replace(/"([^"]+)":/g, '$1:')}
      },`
    })

    // console.log("sizes", sizes, data.defaultSizes)

    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateModel(modelInfo: {
            id: "${data.id}",
            name: "${data.name}",
            type: {
              id: "${data.type.id}",
              name: "${data.type.name}",
              urls: {
                dev: "${data.type.urls.dev}",
                tes: "${data.type.urls.tes}",
                pro: "${data.type.urls.pro}",
              }
              index: ${data.type.index}
            },
            infobox: {
              id: "${data.infobox.id}",
              uiIndex: "${data.infobox.uiIndex}",
              name: "${data.infobox.name}"
            },
            infoboxIsOnline: ${data.infoboxIsOnline},
            category: {
              id: "${data.category.id}",
              name: "${data.category.name}"
            },
            online: ${data.online},
            maatwerk: {
              enabled: ${data.maatwerk.enabled},
              width: {
                min: ${data.maatwerk.width.min},
                max: ${data.maatwerk.width.max}
              },
              depth: {
                min: ${data.maatwerk.depth.min},
                max: ${data.maatwerk.depth.max}
              }
            },
            standaardmatenDisabled: ${data.standaardmatenDisabled},
            wall: {
              minWallWidth: ${data.wall.minWallWidth},
              needsSpaceForStaander: ${data.wall.needsSpaceForStaander}
            },
            roofFinishes: ${JSON.stringify(data.roofFinishes)},
            wallFinishes: ${JSON.stringify(data.wallFinishes).replace(/"([^"]+)":/g, '$1:')}
            overstekKlosRound: ${data.overstekKlosRound},
            availableOptions: {
              fundering: ${data.availableOptions.fundering},
              dakgoot: ${data.availableOptions.dakgoot},
              lichtstraten: ${data.availableOptions.lichtstraten},
              ledverlichting: ${data.availableOptions.ledverlichting},
            },
            meshNames: {
              staander: "${data.meshNames.staander}",
              poer: "${data.meshNames.poer}",
              betonband: "${data.meshNames.betonband}",
              poerenplan: "${data.meshNames.poerenplan}",
              regelwerk: "${data.meshNames.regelwerk}",
              topgevel: "${data.meshNames.topgevel}",
              assets: "${data.meshNames.assets}",
              assetsWandvak: "${data.meshNames.assetsWandvak}",
              asset: "${data.meshNames.asset}",
              lichtstraatGordingbalk: "${data.meshNames.lichtstraatGordingbalk}",
              tulp: "${data.meshNames.tulp}"
            },
            defaultSizes: [${sizes}],
          }) {
            id
            name
            type {
              id
              name
              urls {
                dev
                tes
                pro
              }
              index
            }
            category {
              id
              name
            }
            online
            maatwerk {
              enabled
              width {
                min
                max
              }
              depth {
                min
                max
              }
            }
            standaardmatenDisabled
            wall {
              minWallWidth
              needsSpaceForStaander
            }
            roofFinishes
            wallFinishes {
              wandBuiten
              wandBinnen
              tussenWandLinks
              tussenWandRechts
              topgevelBuiten
              topgevelBinnen
              topgevelLinks
              topgevelRechts
            }
            overstekKlosRound
            availableOptions {
              fundering
              dakgoot
              lichtstraten
              ledverlichting
            }
            meshNames {
              staander
              poer
              betonband
              poerenplan
              regelwerk
              topgevel
              assets
              assetsWandvak
              asset
              lichtstraatGordingbalk
              tulp
            }
            defaultSizes {
              enabled
              diepte
              hoogtePaal
              maximaleMuurBreedte
              staanderDikte
              poer {
                z
                y
              }
              schoor {
                enabled
                meshName
                sz
                sy
                sx
                sox
                wallMinWidth
              }
              ringBalk {
                meshName
                hoekverbinding
                y
                z
              }
              extraRingBalk {
                enabled
                meshName
                gordingVorm
                y
                z
                position
              }
              ringbalkTussenPaal {
                enabled
                meshName
                y
                z
              }
              gordingBalk {
                meshName
                y
                z
                afstandTussenGordingen
                position
                ox
                oy
                oyl
              }
              extraBalkOpGording {
                enabled
                meshName
                y
                z
              }
              extraPlankAchter {
                enabled
                meshName
                y
                z
                xBov
                xOnd
                yKop
              }
              ringBalkGording {
                meshName
                y
                z
                position
              }
              overstekKlos {
                enabled
                meshName
                z
                zp
                xb
                xo
                y
                yk
                position{
                  left
                  right
                }
                zDik
                zDikPaal
                klosVoEnabled
                klosVoEditable
                xBovVo
                xOndVo
                yHooVo
                yKopVo
                klosAcEnabled
                klosAcEditable
                xBovAc
                xOndAc
                yHooAc
                yKopAc
                klosLiEnabled
                klosLiEditable
                xBovLi
                xOndLi
                yHooLi
                yKopLi
                klosReEnabled
                klosReEditable
                xBovRe
                xOndRe
                yHooRe
                yKopRe
                outsideMarginPraag
                losseKopMaxHartAfstand
              }
              boeideel {
                enabled
                boeideelPlankMeshName
                boeideelLijstMeshName
                dekplankMeshName
                douglasPlankenMeshName
                y
                z
                position
                lijstEnabled
                ly
                lz
                lijstPosition
                dpy
                dpz
                dpOffsetKopkant
                dpOffsetGootzijde
                nokpositie
                byl
                bylAchter
                douglasPlanken
                horizontaleOffset
                niceRegelwerkBreedte
                niceRegelwerkDikte
                niceRegelwerkMax
                niceRegelwerkVerticalBeamMaxGap
                niceRegelwerkMinLength
                niceRegelwerkMeshName
              }
              trim {
                enabled
                meshName
                y
                z
                overhang
                color
                position
              }
              dak {
                dakbeschotMeshName
                dakbedekkingMeshName
                offset
                helling
                hellingAchter
                overhang
                beschotDikte
                dakpanOverhang
                dakpanOverhangAchter
                gordingSchoorHoek
                gordingSchoorOffset
                dakbedekkingOpstand
              }
              dakgoot {
                enabled
                meshName
                y
                offset
                offsetAchter
                twoPipesWidth
                threePipesWidth
              }
              wall {
                meshName
                position
                wz
                height {
                  position
                  value
                }
              }
              omlijstingPalen
              omlijstingPalenData {
                meshName
                meshNameOnderplank
              }
              veranda {
                enabled
                meshName
                hoogte
                dikte
                extraBreedte
                material
              }
              breedtes {
                breedte
                bergingType
                artikelNummer
                wallDivision {
                  width
                  bergingEnabled
                }
                enabled
              }
            }
          }
        }
      `
    } 
    // console.log(graphqlQuery)
    // console.log(JSON.stringify(data.wallFinishes))
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update model.')
    }

    await context.dispatch('getModelsInfo')
    await context.dispatch('updateDWTables', {
      succesText: 'Model succesvol geupdate.',
      tableData: response.data.updateModel,
      menuName: "updateModel"
    })
  },

  async createSchuifwandType (context, data) {
    // console.log("data", data)
    const graphqlQuery = {
      query: `
        mutation {
          createSchuifwandType(schuifwandType: {
            minimaleBreedte: ${data.minimaleBreedte},
            maximaleBreedte: ${data.maximaleBreedte},
            glasplaatAantal: ${data.glasplaatAantal},
            glasplaatBreedte: ${data.glasplaatBreedte},
            glasplaatDikte: ${data.glasplaatDikte},
            bovenrailHoogte: ${data.bovenrailHoogte},
            onderrailHoogte: ${data.onderrailHoogte},
            railDikte: ${data.railDikte},
            glaspaneelHartAfstand: ${data.glaspaneelHartAfstand},
            glasprofielStaanderBreedte: ${data.glasprofielStaanderBreedte},
            glasprofielStaanderDikte: ${data.glasprofielStaanderDikte},
            glasprofielLiggerBreedte: ${data.glasprofielLiggerBreedte},
            glasprofielLiggerDikte: ${data.glasprofielLiggerDikte},
            handvatVerticalePositionering: ${data.handvatVerticalePositionering},
            handvatHorizontalePositionering: ${data.handvatHorizontalePositionering},
            schuifrichting: "${data.schuifrichting}",
            artikelnummers: ${JSON.stringify(data.artikelnummers)},
            order: ${data.order},
            ${data.image ? 'image: "'+data.image+'"' : ''}
          }) {
            id
            minimaleBreedte
            maximaleBreedte
            glasplaatAantal
            glasplaatBreedte
            glasplaatDikte
            bovenrailHoogte
            onderrailHoogte
            railDikte
            glaspaneelHartAfstand
            glasprofielStaanderBreedte
            glasprofielStaanderDikte
            glasprofielLiggerBreedte
            glasprofielLiggerDikte
            handvatVerticalePositionering
            handvatHorizontalePositionering
            schuifrichting
            artikelnummers
            order
            image
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to create schuifwand type.')
    }

    context.commit('setSchuifwandTypes', response.data.createSchuifwandType)
    context.dispatch('showSucces', 'Schuifwand type succesvol gecreërd.')
  },

  async updateSchuifwandType (context, data) {
    // console.log(data)
    const graphqlQuery = {
      query: `
        mutation {
          updateSchuifwandType(schuifwandType: {
            id: "${data.id}",
            minimaleBreedte: ${data.minimaleBreedte},
            maximaleBreedte: ${data.maximaleBreedte},
            glasplaatAantal: ${data.glasplaatAantal},
            glasplaatBreedte: ${data.glasplaatBreedte},
            glasplaatDikte: ${data.glasplaatDikte},
            bovenrailHoogte: ${data.bovenrailHoogte},
            onderrailHoogte: ${data.onderrailHoogte},
            railDikte: ${data.railDikte},
            glaspaneelHartAfstand: ${data.glaspaneelHartAfstand},
            glasprofielStaanderBreedte: ${data.glasprofielStaanderBreedte},
            glasprofielStaanderDikte: ${data.glasprofielStaanderDikte},
            glasprofielLiggerBreedte: ${data.glasprofielLiggerBreedte},
            glasprofielLiggerDikte: ${data.glasprofielLiggerDikte},
            handvatVerticalePositionering: ${data.handvatVerticalePositionering},
            handvatHorizontalePositionering: ${data.handvatHorizontalePositionering},
            schuifrichting: "${data.schuifrichting}",
            artikelnummers: ${JSON.stringify(data.artikelnummers)},
            order: ${data.order},
            ${data.image ? 'image: "'+data.image+'"' : ''}
          }) {
            id
            minimaleBreedte
            maximaleBreedte
            glasplaatAantal
            glasplaatBreedte
            glasplaatDikte
            bovenrailHoogte
            onderrailHoogte
            railDikte
            glaspaneelHartAfstand
            glasprofielStaanderBreedte
            glasprofielStaanderDikte
            glasprofielLiggerBreedte
            glasprofielLiggerDikte
            handvatVerticalePositionering
            handvatHorizontalePositionering
            schuifrichting
            artikelnummers
            order
            image
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update schuifwand type.')
    }

    context.commit('setSchuifwandTypes', response.data.updateSchuifwandType)
    context.dispatch('showSucces', 'Schuifwand type succesvol geupdate.')
  },

  async deleteSchuifwandType (context, id) {
    const graphqlQuery = {
      query: `
        mutation {
          deleteSchuifwandType(id: "${id}") {
            id
            minimaleBreedte
            maximaleBreedte
            glasplaatAantal
            glasplaatBreedte
            glasplaatDikte
            bovenrailHoogte
            onderrailHoogte
            railDikte
            glaspaneelHartAfstand
            glasprofielStaanderBreedte
            glasprofielStaanderDikte
            glasprofielLiggerBreedte
            glasprofielLiggerDikte
            handvatVerticalePositionering
            handvatHorizontalePositionering
            schuifrichting
            artikelnummers
            order
            image
          }
        }
      `
    }

    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to delete schuifwand type.')
    }

    context.commit('setSchuifwandTypes', response.data.deleteSchuifwandType)
    // console.log("response.data.deleteSchuifwandType", response.data.deleteSchuifwandType)
    context.dispatch('showSucces', 'Schuifwand type succesvol verwijderd.')
  },

  async setTextureScaling (context, data) {
    // console.log(context, data)

    const textureData = {
      id: data.id,
      name: data.name,
      url: data.previewURL,
      scalingX: parseFloat(data.scalingX),
      scalingY: parseFloat(data.scalingY),
      emissive: parseFloat(data.emissive),
      emissiveColor: data.emissiveColor,
      metalness: parseFloat(data.metalness),
    }
    
    const graphqlQuery = {
      query: `
        mutation {
          updateTexture(update: ${JSON.stringify(textureData).replace(/"([^"]+)":/g, '$1:')}) {
            id
            name
            url
            textureType
            plankType
            color
            locations
          }
        }
      `
    }
    // console.log(graphqlQuery)

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // console.log(response)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update texture.')
    }

  },

  async getUsers (context) {
    const graphqlQuery = {
      query: `
        {
          getUsers {
            id
            email
            superUser
            collectionsAllowedToEdit
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get users.')
    }

    context.commit('setUsers', response.data.getUsers)
  },

  async getUser (context) {
    const graphqlQuery = {
      query: `
        {
          getUser {
            id
            email
            superUser
            collectionsAllowedToEdit
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get user.')
    }

    context.commit('setUser', response.data.getUser)
  },

  async getMaterials (context) {
    const graphqlQuery = {
      query: `
        {
          getMaterials {
            id
            name
            width
            height
            color
            diffusemap
            normalmap
            aomap
            metalnessmap
            roughnessmap
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get materials.')
    }

    context.commit('setMaterials', response.data.getMaterials)
  },

  async updateMaterials (context, materials) {
    const remove = materials.remove.map((x) => {
      return `{
        id: "${x.id}"
      }`
    })

    const update = materials.update.map((x) => {
      // console.log(materials.update)
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        width: ${x.width},
        height: ${x.height},
        color: "${x.color}",
        diffusemap: "${x.diffusemap}",
        normalmap: "${x.normalmap}",
        aomap: "${x.aomap}",
        metalnessmap: "${x.metalnessmap}",
        roughnessmap: "${x.roughnessmap}"
      }`
    })

    const insert = materials.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        width: ${x.width},
        height: ${x.height},
        color: "${x.color}",
        diffusemap: "${x.diffusemap}",
        normalmap: "${x.normalmap}",
        aomap: "${x.aomap}",
        metalnessmap: "${x.metalnessmap}",
        roughnessmap: "${x.roughnessmap}"
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateMaterials(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            width
            height
            color
            diffusemap
            normalmap
            aomap
            metalnessmap
            roughnessmap
          }
        }
      `
    }
    // console.log(graphqlQuery)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update materials.')
    }

    context.commit('setMaterials', response.data.updateMaterials)
  },

  async getFunderingTypes (context) {
    const graphqlQuery = {
      query: `
        {
          getFunderingTypes {
            id
            name
            artikelCode
            label
            description
            uiImage
            infobox
            poerenEnabled
            vloerEnabled
            vloerMaterial
            isDefault
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get fundering types.')
    }

    context.commit('setFunderingTypes', response.data.getFunderingTypes)
  },

  async getFunderingTypesPublic (context) {
    const graphqlQuery = {
      query: `
        {
          getFunderingTypesPublic {
            id
            name
            artikelCode
            label
            description
            uiImage {
              url
            }
            infobox
            poerenEnabled
            vloerEnabled
            vloerMaterial {
              diffusemap {
                url
              }
              width
              height
            }
            isDefault
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get fundering types.')
    }

    context.commit('setFunderingTypesPublic', response.data.getFunderingTypesPublic)

    // set default fundering type if not set
    let funderingType
    if (store.state.config.config.funderingType) {
      funderingType = response.data.getFunderingTypesPublic.find(type => type.id === store.state.config.config.funderingType)
    } else {
      funderingType = response.data.getFunderingTypesPublic.find(type => type.isDefault)
    }
    if (funderingType) {
      // console.log("prdv", funderingType)
      store.dispatch('updateFoundationType', funderingType)
      store.dispatch('updateFoundation', funderingType.poerenEnabled)
    }
  },

  async updateFunderingTypes (context, funderingTypes) {
    const remove = funderingTypes.remove.map((x) => {
      return `{
        id: "${x.id}"
      }`
    })

    const update = funderingTypes.update.map((x) => {
      // console.log(funderingTypes.update)
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        artikelCode: "${x.artikelCode}",
        label: "${x.label}",
        description: "${x.description}",
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        poerenEnabled: ${x.poerenEnabled},
        vloerEnabled: ${x.vloerEnabled},
        vloerMaterial: "${x.vloerMaterial}",
        isDefault: ${x.isDefault}
      }`
    })

    const insert = funderingTypes.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        artikelCode: "${x.artikelCode}",
        label: "${x.label}",
        description: "${x.description}",
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        poerenEnabled: ${x.poerenEnabled},
        vloerEnabled: ${x.vloerEnabled},
        vloerMaterial: "${x.vloerMaterial}",
        isDefault: ${x.isDefault}
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateFunderingTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            artikelCode
            label
            description
            uiImage
            infobox
            poerenEnabled
            vloerEnabled
            vloerMaterial
            isDefault
          }
        }
      `
    }
    // console.log(graphqlQuery)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update fundering types.')
    }

    context.commit('setFunderingTypes', response.data.updateFunderingTypes)
  },

  async getGlobalSettings (context) {
    const graphqlQuery = {
      query: `
        {
          getGlobalSettings {
            lichtstraatBorderMargin
            lichtstraatBetweenMargin
            lichtstraatMapColor
            lichtstraatMapLineColor
            lichtstraatMapLineColorSelected
          }
        }
      `
    }
    // console.log(graphqlQuery)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to fetch global settings.')
    }

    context.commit('setGlobalSettings', response.data.getGlobalSettings)
  },

  async updateGlobalSettings (context, data) {
    const graphqlQuery = {
      query: `
        mutation {
          updateGlobalSettings(
            lichtstraatBorderMargin: ${data.lichtstraatBorderMargin}, 
            lichtstraatBetweenMargin: ${data.lichtstraatBetweenMargin},
            lichtstraatMapColor: "${data.lichtstraatMapColor}",
            lichtstraatMapLineColor: "${data.lichtstraatMapLineColor}",
            lichtstraatMapLineColorSelected: "${data.lichtstraatMapLineColorSelected}"
          ) {
            lichtstraatBorderMargin
            lichtstraatBetweenMargin
            lichtstraatMapColor
            lichtstraatMapLineColor
            lichtstraatMapLineColorSelected
          } 
        }
      `
    }
    // console.log(graphqlQuery)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update global settings.')
    }

    context.commit('setGlobalSettings', response.data.updateGlobalSettings)
  },

  async getDakgootTypes (context) {
    const graphqlQuery = {
      query: `
        {
          getDakgootTypes {
            id
            name
            isDefault
            label
            description
            uiImage
            infobox
            infoboxOnline
            textLeft
            textRight
            colors {
              id
              label
              hexcode
              uiHexcode
              artikelCode
              isDefault
            }
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get dakgootTypes.')
    }

    context.commit('setDakgootTypes', response.data.getDakgootTypes)
  },

  async getDakgootTypesPublic (context) {
    const graphqlQuery = {
      query: `
        {
          getDakgootTypesPublic {
            id
            name
            isDefault
            label
            description
            uiImage {
              url
            }
            infobox
            infoboxOnline
            textLeft
            textRight
            colors {
              id
              label
              hexcode
              uiHexcode
              artikelCode
              isDefault
            }
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get dakgootTypes.')
    }

    context.commit('setDakgootTypesPublic', response.data.getDakgootTypesPublic)

    // set default dakgoot type if not set
    // let dakgootTypeVoor
    // if (store.state.config.config.dakgoot.front.dakgootType) {
    //   dakgootTypeVoor = response.data.getDakgootTypesPublic.find(type => type.id === store.state.config.config.dakgoot.front.dakgootType)
    // } else {
    //   dakgootTypeVoor = response.data.getDakgootTypesPublic.find(type => type.isDefault)
    // }
    // if (dakgootTypeVoor) {
    //   const dakgootObject = JSON.parse(JSON.stringify(store.state.config.config.dakgoot.front))
    //   dakgootObject.name = "Voorzijde"
    //   dakgootObject.dakgootType = dakgootTypeVoor.id
    //   const dakgootColorVoor = dakgootTypeVoor.colors.find(color => color.isDefault)
    //   if (dakgootColorVoor) {
    //     dakgootObject.dakgootColor = dakgootColorVoor.id
    //   } else {
    //     dakgootObject.dakgootColor = dakgootTypeVoor.colors.find(color => color.isDefault).id
    //   }
    //   if (!dakgootObject.dakgootColor) {
    //     dakgootObject.dakgootColor = dakgootTypeVoor.colors[0].id
    //   }
    //   store.dispatch('updateDakgoot', dakgootObject)
    // }

    // let dakgootTypeAchter
    // if (store.state.config.config.dakgoot.back.dakgootType) {
    //   dakgootTypeAchter = response.data.getDakgootTypesPublic.find(type => type.id === store.state.config.config.dakgoot.back.dakgootType)
    // } else {
    //   dakgootTypeAchter = response.data.getDakgootTypesPublic.find(type => type.isDefault)
    // }
    // if (dakgootTypeAchter) {
    //   const dakgootObject = JSON.parse(JSON.stringify(store.state.config.config.dakgoot.back))
    //   dakgootObject.name = "Achterzijde"
    //   dakgootObject.dakgootType = dakgootTypeAchter.id
    //   const dakgootColorAchter = dakgootTypeAchter.colors.find(color => color.isDefault)
    //   if (dakgootColorAchter) {
    //     dakgootObject.dakgootColor = dakgootColorAchter.id
    //   } else {
    //     dakgootObject.dakgootColor = dakgootTypeAchter.colors.find(color => color.isDefault).id
    //   }
    //   if (!dakgootObject.dakgootColor) {
    //     dakgootObject.dakgootColor = dakgootTypeAchter.colors[0].id
    //   }
    //   store.dispatch('updateDakgoot', dakgootObject)
    // }
  },

  async updateDakgootTypes (context, dakgootTypes) {
    const remove = dakgootTypes.remove.map((x) => {
      return `{
        id: "${x.id}"
      }`
    })

    const update = dakgootTypes.update.map((x) => {
      return `{
        id: "${x.id}", 
        name: "${x.name}",
        isDefault: ${x.isDefault},
        label: "${x.label}",
        description: "${x.description}",
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        infoboxOnline: ${x.infoboxOnline},
        textLeft: "${x.textLeft}",
        textRight: "${x.textRight}",
        colors: ${JSON.stringify(x.colors).replace(/"([^"]+)":/g, '$1:')},
      }`
    })

    const insert = dakgootTypes.insert.map((x) => {
      return `{
        id: "", 
        name: "${x.name}",
        isDefault: ${x.isDefault},
        label: "${x.label}",
        description: "${x.description}",
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        infoboxOnline: ${x.infoboxOnline},
        textLeft: "${x.textLeft}",
        textRight: "${x.textRight}",
        colors: ${JSON.stringify(x.colors).replace(/"([^"]+)":/g, '$1:')},
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateDakgootTypes(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            name
            isDefault
            label
            description
            uiImage
            infobox
            infoboxOnline
            textLeft
            textRight
            colors {
              id
              label
              hexcode
              uiHexcode
              artikelCode
              isDefault
            }
          }
        }
      `
    }
    // console.log(graphqlQuery, dakgootTypes)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update dakgoot types.')
    }

    context.commit('setDakgootTypes', response.data.updateDakgootTypes)
  },
  
  async getInfoboxes (context) {
    const graphqlQuery = {
      query: `
        {
          getMenuInfoboxSettings {
            id
            uiIndex
            name
            title
            header
            urlEnding
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get infoboxes.')
    }

    context.commit('setInfoboxes', response.data.getMenuInfoboxSettings)
  },

  async getSchuifwandOptions (context) {
    const graphqlQuery = {
      query: `
        {
          getSchuifwandOptions {
            id
            keyName
            label
            uiImage
            infobox
            defaultOn
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get schuifwandOptions.')
    }

    context.commit('setSchuifwandOptions', response.data.getSchuifwandOptions)
  },

  async getSchuifwandOptionsPublic (context) {
    const graphqlQuery = {
      query: `
        {
          getSchuifwandOptionsPublic {
            id
            keyName
            label
            uiImage {
              url
            }
            infobox
            defaultOn
          }
        }
      `
    }

    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to get schuifwandOptions.')
    }

    context.commit('setSchuifwandOptionsPublic', response.data.getSchuifwandOptionsPublic)

    // set defaults
    context.commit('setConfigSchuifwandOptions', { 
      tochtborstel: response.data.getSchuifwandOptionsPublic.find((x) => x.keyName === 'tochtborstel')?.defaultOn || false,
      meeneemset: response.data.getSchuifwandOptionsPublic.find((x) => x.keyName === 'meeneemset')?.defaultOn || false,
      slotset: response.data.getSchuifwandOptionsPublic.find((x) => x.keyName === 'slot set')?.defaultOn || false,
      funderingskoker: response.data.getSchuifwandOptionsPublic.find((x) => x.keyName === 'funderingskoker')?.defaultOn || false,
      schuifwandachtershutter: response.data.getSchuifwandOptionsPublic.find((x) => x.keyName === 'schuifwand achter shutter')?.defaultOn || false
    })
  },

  async updateSchuifwandOptions (context, schuifwandOptions) {
    const remove = schuifwandOptions.remove.map((x) => {
      return `{
        id: "${x.id}"
      }`
    })

    const update = schuifwandOptions.update.map((x) => {
      return `{
        id: "${x.id}", 
        keyName: "${x.keyName}",
        label: "${x.label}" ,
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        defaultOn: ${x.defaultOn},
      }`
    })

    const insert = schuifwandOptions.insert.map((x) => {
      return `{
        id: "", 
        keyName: "${x.keyName}",
        label: "${x.label}" ,
        uiImage: "${x.uiImage}",
        infobox: "${x.infobox}",
        defaultOn: ${x.defaultOn},
      }`
    })



    // config graphQL data
    const graphqlQuery = {
      query: `
        mutation {
          updateSchuifwandOptions(remove: [${remove}], update: [${update}], insert: [${insert}]) {
            id
            keyName
            label
            uiImage
            infobox
            defaultOn
          }
        }
      `
    }
    // console.log(graphqlQuery, schuifwandOptions)
    // sending request to server
    const response = await graphql.fetchGraphQL(context, graphqlQuery, context.rootState.user.userAccount.token)

    // if error
    if (response.errors) {
      errorHandeling.throwError(context, response, 'Failed to update dakgoot types.')
    }

    context.commit('setSchuifwandOptions', response.data.updateSchuifwandOptions)
  },
}

const getters = {

  getCMSComponents (state) {
    return state.CMSComponents
  },

  getMenuColors (state) {
    return state.menuColors
  },

  getMeshNames (state) {
    return state.meshNames
  },

  getMenuGlasTypes (state) {
    return state.menuGlasTypes
  },

  getMenuIsolatieTypes (state) {
    return state.menuIsolatieTypes
  },

  getMenuInfoboxSettings (state) {
    return state.menuInfoboxSettings
  },

  getMenuUISettings (state) {
    return state.menuUISettings
  },

  getTextures (state) {
    return state.textures
  },

  getTextureTypes (state) {
    return state.textureTypes
  },

  getHoutsoortTypes (state) {
    // console.log("getHoutsoortTypes", state.houtsoortTypes)
    return state.houtsoortTypes
  },

  getPlankTypes (state) {
    return state.plankTypes
  },

  getPlankLocations (state) {
    return state.plankLocations
  },

  getNewComponent (state) {
    return state.newComponent
  },

  getTypes (state) {
    return state.types
  },

  getInfoboxes (state) {
    return state.infoboxes
  },

  getModelCategories (state) {
    return state.modelCategories
  },

  getBergingTypes (state) {
    return state.bergingTypes
  },

  getSchuifwandTypes (state) {
    return state.schuifwandTypes
  },

  getSchuifwandWidthRanges (state) {
    return state.schuifwandWidthRanges
  },

  getModels (state) {
    return state.models
  },

  getUsers (state) {
    return state.users
  },

  getUser (state) {
    return state.user
  },

  getBackups (state) {
    return state.backups
  },

  getMaterials (state) {
    return state.materials
  },

  getFunderingTypes (state) {
    return state.funderingTypes
  },

  getFunderingTypesPublic (state) {
    return state.funderingTypesPublic
  },

  getGlobalSettings (state) {
    return state.globalSettings
  },

  getDakgootTypes (state) {
    return state.dakgootTypes
  },

  getDakgootTypesPublic (state) {
    return state.dakgootTypesPublic
  },
    
   getSchuifwandOptions (state) {
    return state.schuifwandOptions
  },

  getSchuifwandOptionsPublic (state) {
    return state.schuifwandOptionsPublic
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}